//----------------------
// <auto-generated>
//     Split from WebApiController.ts
//     Regenerate with: node scripts/splitWebApiController.js
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming


import { PosClientBase, PosClientConfig, throwException } from './base';
import type { CatalogCounts, CommissionReportV2Request, CostOfGoodsSoldReportV2Request, FileExportProgress, FileExportResult, FileResponse, InventoryReportV2Request, ListingReportMetricsDownloadRequest, ListingReportMetricsRequest, ListingReportMetricsResponse, PurchaseOrderLineItemReportV2Request, PurchaseReportV2Request, ReportConfigOfListingQueryAndReportWidgetTypesInventory, ReportConfigOfSaleQueryAndReportWidgetTypesNone, ReportConfigOverrideOfListingQuery, ReportConfigOverrideOfSaleQuery, ReportFileType, ReportMetricsSummaryV2, ReportMetricsV2, ReportSnapshotInfo, ReportV2ConfigOfCommissionReportV2RequestAndReportWidgetTypesNone, ReportV2ConfigOfCostOfGoodsSoldReportV2RequestAndReportWidgetTypesNone, ReportV2ConfigOfInventoryReportV2RequestAndReportWidgetTypesInventory, ReportV2ConfigOfPurchaseOrderLineItemReportV2RequestAndReportWidgetTypesNone, ReportV2ConfigOfPurchaseReportV2RequestAndReportWidgetTypesNone, ReportV2ConfigOfSaleLineItemReportV2RequestAndReportWidgetTypesNone, ReportV2ConfigOfSaleTotalCostAdjustmentReportV2RequestAndReportWidgetTypesNone, ReportV2ConfigOfSalesReportV2RequestAndReportWidgetTypesNone, ReportV2ConfigOfSoldTicketReportV2RequestAndReportWidgetTypesNone, ReportV2ConfigOfTicketGroupReportV2RequestAndReportWidgetTypesNone, ReportV2ConfigOverride, SaleLineItemReportV2Request, SaleReportMetricsDownloadRequest, SaleReportMetricsRequest, SaleReportMetricsResponse, SaleTotalCostAdjustmentReportV2Request, SalesReportV2Request, SoldTicketReportV2Request, TicketGroupReportV2Request, UIReportV2CostOfGoodsSoldQuery, UIReportV2ListingQuery, UIReportV2SaleLineItemQuery, UIReportV2SaleQuery, UIReportV2SaleTotalCostAdjustmentsQuery, UIReportV2SoldTicketQuery, UIReportV2TicketGroupQuery } from './types';


export interface IReportClient {

    getAvailableInventoryReportConfig(): Promise<ReportConfigOfListingQueryAndReportWidgetTypesInventory[]>;

    upsertInventoryReportConfig(reportConfig: ReportConfigOfListingQueryAndReportWidgetTypesInventory): Promise<number | null>;

    upsertInventoryReportConfigOverride(reportConfigId: number | undefined, reportConfigOverride: ReportConfigOverrideOfListingQuery): Promise<boolean>;

    getAvailableSaleReportConfig(): Promise<ReportConfigOfSaleQueryAndReportWidgetTypesNone[]>;

    upsertSaleReportConfig(reportConfig: ReportConfigOfSaleQueryAndReportWidgetTypesNone): Promise<number | null>;

    upsertSaleReportConfigOverride(reportConfigId: number | undefined, reportConfigOverride: ReportConfigOverrideOfSaleQuery): Promise<boolean>;

    deleteReportConfig(reportConfigId: number | undefined): Promise<boolean>;

    getListingReportMetrics(input: ListingReportMetricsRequest, maxResultsize: number | null | undefined): Promise<ListingReportMetricsResponse>;

    getSaleReportMetrics(input: SaleReportMetricsRequest, maxResultsize: number | null | undefined): Promise<SaleReportMetricsResponse>;

    getReportSnapshotInfos(reportConfigId: number | undefined): Promise<ReportSnapshotInfo[]>;

    downloadSaleReportMetrics(input: SaleReportMetricsDownloadRequest): Promise<FileResponse>;

    downloadListingReportMetrics(input: ListingReportMetricsDownloadRequest): Promise<FileResponse>;
}

export class ReportClient extends PosClientBase implements IReportClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAvailableInventoryReportConfig(signal?: AbortSignal | undefined): Promise<ReportConfigOfListingQueryAndReportWidgetTypesInventory[]> {
        let url_ = this.baseUrl + "/api/Report/GetAvailableInventoryReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableInventoryReportConfig(_response);
        });
    }

    protected processGetAvailableInventoryReportConfig(response: Response): Promise<ReportConfigOfListingQueryAndReportWidgetTypesInventory[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportConfigOfListingQueryAndReportWidgetTypesInventory[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportConfigOfListingQueryAndReportWidgetTypesInventory[]>(null as any);
    }

    upsertInventoryReportConfig(reportConfig: ReportConfigOfListingQueryAndReportWidgetTypesInventory, signal?: AbortSignal | undefined): Promise<number | null> {
        let url_ = this.baseUrl + "/api/Report/UpsertInventoryReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportConfig);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertInventoryReportConfig(_response);
        });
    }

    protected processUpsertInventoryReportConfig(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    upsertInventoryReportConfigOverride(reportConfigId: number | undefined, reportConfigOverride: ReportConfigOverrideOfListingQuery, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Report/UpsertInventoryReportConfigOverride?";
        if (reportConfigId === null)
            throw new Error("The parameter 'reportConfigId' cannot be null.");
        else if (reportConfigId !== undefined)
            url_ += "reportConfigId=" + encodeURIComponent("" + reportConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportConfigOverride);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertInventoryReportConfigOverride(_response);
        });
    }

    protected processUpsertInventoryReportConfigOverride(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getAvailableSaleReportConfig(signal?: AbortSignal | undefined): Promise<ReportConfigOfSaleQueryAndReportWidgetTypesNone[]> {
        let url_ = this.baseUrl + "/api/Report/GetAvailableSaleReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableSaleReportConfig(_response);
        });
    }

    protected processGetAvailableSaleReportConfig(response: Response): Promise<ReportConfigOfSaleQueryAndReportWidgetTypesNone[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportConfigOfSaleQueryAndReportWidgetTypesNone[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportConfigOfSaleQueryAndReportWidgetTypesNone[]>(null as any);
    }

    upsertSaleReportConfig(reportConfig: ReportConfigOfSaleQueryAndReportWidgetTypesNone, signal?: AbortSignal | undefined): Promise<number | null> {
        let url_ = this.baseUrl + "/api/Report/UpsertSaleReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportConfig);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertSaleReportConfig(_response);
        });
    }

    protected processUpsertSaleReportConfig(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    upsertSaleReportConfigOverride(reportConfigId: number | undefined, reportConfigOverride: ReportConfigOverrideOfSaleQuery, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Report/UpsertSaleReportConfigOverride?";
        if (reportConfigId === null)
            throw new Error("The parameter 'reportConfigId' cannot be null.");
        else if (reportConfigId !== undefined)
            url_ += "reportConfigId=" + encodeURIComponent("" + reportConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportConfigOverride);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertSaleReportConfigOverride(_response);
        });
    }

    protected processUpsertSaleReportConfigOverride(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    deleteReportConfig(reportConfigId: number | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Report/DeleteReportConfig?";
        if (reportConfigId === null)
            throw new Error("The parameter 'reportConfigId' cannot be null.");
        else if (reportConfigId !== undefined)
            url_ += "reportConfigId=" + encodeURIComponent("" + reportConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteReportConfig(_response);
        });
    }

    protected processDeleteReportConfig(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getListingReportMetrics(input: ListingReportMetricsRequest, maxResultsize: number | null | undefined, signal?: AbortSignal | undefined): Promise<ListingReportMetricsResponse> {
        let url_ = this.baseUrl + "/api/Report/GetListingReportMetrics?";
        if (maxResultsize !== undefined && maxResultsize !== null)
            url_ += "maxResultsize=" + encodeURIComponent("" + maxResultsize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListingReportMetrics(_response);
        });
    }

    protected processGetListingReportMetrics(response: Response): Promise<ListingReportMetricsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListingReportMetricsResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingReportMetricsResponse>(null as any);
    }

    getSaleReportMetrics(input: SaleReportMetricsRequest, maxResultsize: number | null | undefined, signal?: AbortSignal | undefined): Promise<SaleReportMetricsResponse> {
        let url_ = this.baseUrl + "/api/Report/GetSaleReportMetrics?";
        if (maxResultsize !== undefined && maxResultsize !== null)
            url_ += "maxResultsize=" + encodeURIComponent("" + maxResultsize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSaleReportMetrics(_response);
        });
    }

    protected processGetSaleReportMetrics(response: Response): Promise<SaleReportMetricsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SaleReportMetricsResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaleReportMetricsResponse>(null as any);
    }

    getReportSnapshotInfos(reportConfigId: number | undefined, signal?: AbortSignal | undefined): Promise<ReportSnapshotInfo[]> {
        let url_ = this.baseUrl + "/api/Report/GetReportSnapshotInfos?";
        if (reportConfigId === null)
            throw new Error("The parameter 'reportConfigId' cannot be null.");
        else if (reportConfigId !== undefined)
            url_ += "reportConfigId=" + encodeURIComponent("" + reportConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReportSnapshotInfos(_response);
        });
    }

    protected processGetReportSnapshotInfos(response: Response): Promise<ReportSnapshotInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportSnapshotInfo[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportSnapshotInfo[]>(null as any);
    }

    downloadSaleReportMetrics(input: SaleReportMetricsDownloadRequest, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Report/DownloadSaleReportMetrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadSaleReportMetrics(_response);
        });
    }

    protected processDownloadSaleReportMetrics(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    downloadListingReportMetrics(input: ListingReportMetricsDownloadRequest, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Report/DownloadListingReportMetrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadListingReportMetrics(_response);
        });
    }

    protected processDownloadListingReportMetrics(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}
export interface IReportV2ConfigClient {

    getAvailableInventoryReportConfig(): Promise<ReportV2ConfigOfInventoryReportV2RequestAndReportWidgetTypesInventory[]>;

    upsertInventoryReportConfig(reportConfig: ReportV2ConfigOfInventoryReportV2RequestAndReportWidgetTypesInventory): Promise<number | null>;

    getAvailableSaleReportConfig(): Promise<ReportV2ConfigOfSalesReportV2RequestAndReportWidgetTypesNone[]>;

    upsertSaleReportConfig(reportConfig: ReportV2ConfigOfSalesReportV2RequestAndReportWidgetTypesNone): Promise<number | null>;

    getAvailablePurchaseReportConfig(): Promise<ReportV2ConfigOfPurchaseReportV2RequestAndReportWidgetTypesNone[]>;

    upsertPurchaseReportConfig(reportConfig: ReportV2ConfigOfPurchaseReportV2RequestAndReportWidgetTypesNone): Promise<number | null>;

    getAvailableSaleLineItemReportConfig(): Promise<ReportV2ConfigOfSaleLineItemReportV2RequestAndReportWidgetTypesNone[]>;

    upsertSaleLineItemReportConfig(reportConfig: ReportV2ConfigOfSaleLineItemReportV2RequestAndReportWidgetTypesNone): Promise<number | null>;

    getAvailablePurchaseOrderLineItemReportConfig(): Promise<ReportV2ConfigOfPurchaseOrderLineItemReportV2RequestAndReportWidgetTypesNone[]>;

    upsertPurchaseOrderLineItemReportConfig(reportConfig: ReportV2ConfigOfPurchaseOrderLineItemReportV2RequestAndReportWidgetTypesNone): Promise<number | null>;

    getAvailableSoldTicketReportConfig(): Promise<ReportV2ConfigOfSoldTicketReportV2RequestAndReportWidgetTypesNone[]>;

    upsertSoldTicketReportConfig(reportConfig: ReportV2ConfigOfSoldTicketReportV2RequestAndReportWidgetTypesNone): Promise<number | null>;

    deleteReportConfig(reportConfigId: number | undefined): Promise<boolean>;

    getAvailableCommissionReportConfig(): Promise<ReportV2ConfigOfCommissionReportV2RequestAndReportWidgetTypesNone[]>;

    getAvailableCostOfGoodsSoldReportConfig(): Promise<ReportV2ConfigOfCostOfGoodsSoldReportV2RequestAndReportWidgetTypesNone[]>;

    upsertCostOfGoodsSoldReportConfig(reportConfig: ReportV2ConfigOfCostOfGoodsSoldReportV2RequestAndReportWidgetTypesNone): Promise<number | null>;

    getAvailableSaleTotalCostAdjustmentReportConfig(): Promise<ReportV2ConfigOfSaleTotalCostAdjustmentReportV2RequestAndReportWidgetTypesNone[]>;

    upsertSaleTotalCostAdjustmentReportConfig(reportConfig: ReportV2ConfigOfSaleTotalCostAdjustmentReportV2RequestAndReportWidgetTypesNone): Promise<number | null>;

    getAvailableTicketGroupReportConfig(): Promise<ReportV2ConfigOfTicketGroupReportV2RequestAndReportWidgetTypesNone[]>;

    upsertTicketGroupReportConfig(reportConfig: ReportV2ConfigOfTicketGroupReportV2RequestAndReportWidgetTypesNone): Promise<number | null>;

    upsertReportConfigOverride(reportConfigId: number | undefined, reportConfigOverride: ReportV2ConfigOverride): Promise<boolean>;
}

export class ReportV2ConfigClient extends PosClientBase implements IReportV2ConfigClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAvailableInventoryReportConfig(signal?: AbortSignal | undefined): Promise<ReportV2ConfigOfInventoryReportV2RequestAndReportWidgetTypesInventory[]> {
        let url_ = this.baseUrl + "/api/ReportV2Config/GetAvailableInventoryReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableInventoryReportConfig(_response);
        });
    }

    protected processGetAvailableInventoryReportConfig(response: Response): Promise<ReportV2ConfigOfInventoryReportV2RequestAndReportWidgetTypesInventory[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportV2ConfigOfInventoryReportV2RequestAndReportWidgetTypesInventory[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportV2ConfigOfInventoryReportV2RequestAndReportWidgetTypesInventory[]>(null as any);
    }

    upsertInventoryReportConfig(reportConfig: ReportV2ConfigOfInventoryReportV2RequestAndReportWidgetTypesInventory, signal?: AbortSignal | undefined): Promise<number | null> {
        let url_ = this.baseUrl + "/api/ReportV2Config/UpsertInventoryReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportConfig);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertInventoryReportConfig(_response);
        });
    }

    protected processUpsertInventoryReportConfig(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    getAvailableSaleReportConfig(signal?: AbortSignal | undefined): Promise<ReportV2ConfigOfSalesReportV2RequestAndReportWidgetTypesNone[]> {
        let url_ = this.baseUrl + "/api/ReportV2Config/GetAvailableSaleReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableSaleReportConfig(_response);
        });
    }

    protected processGetAvailableSaleReportConfig(response: Response): Promise<ReportV2ConfigOfSalesReportV2RequestAndReportWidgetTypesNone[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportV2ConfigOfSalesReportV2RequestAndReportWidgetTypesNone[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportV2ConfigOfSalesReportV2RequestAndReportWidgetTypesNone[]>(null as any);
    }

    upsertSaleReportConfig(reportConfig: ReportV2ConfigOfSalesReportV2RequestAndReportWidgetTypesNone, signal?: AbortSignal | undefined): Promise<number | null> {
        let url_ = this.baseUrl + "/api/ReportV2Config/UpsertSaleReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportConfig);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertSaleReportConfig(_response);
        });
    }

    protected processUpsertSaleReportConfig(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    getAvailablePurchaseReportConfig(signal?: AbortSignal | undefined): Promise<ReportV2ConfigOfPurchaseReportV2RequestAndReportWidgetTypesNone[]> {
        let url_ = this.baseUrl + "/api/ReportV2Config/GetAvailablePurchaseReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailablePurchaseReportConfig(_response);
        });
    }

    protected processGetAvailablePurchaseReportConfig(response: Response): Promise<ReportV2ConfigOfPurchaseReportV2RequestAndReportWidgetTypesNone[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportV2ConfigOfPurchaseReportV2RequestAndReportWidgetTypesNone[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportV2ConfigOfPurchaseReportV2RequestAndReportWidgetTypesNone[]>(null as any);
    }

    upsertPurchaseReportConfig(reportConfig: ReportV2ConfigOfPurchaseReportV2RequestAndReportWidgetTypesNone, signal?: AbortSignal | undefined): Promise<number | null> {
        let url_ = this.baseUrl + "/api/ReportV2Config/UpsertPurchaseReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportConfig);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertPurchaseReportConfig(_response);
        });
    }

    protected processUpsertPurchaseReportConfig(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    getAvailableSaleLineItemReportConfig(signal?: AbortSignal | undefined): Promise<ReportV2ConfigOfSaleLineItemReportV2RequestAndReportWidgetTypesNone[]> {
        let url_ = this.baseUrl + "/api/ReportV2Config/GetAvailableSaleLineItemReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableSaleLineItemReportConfig(_response);
        });
    }

    protected processGetAvailableSaleLineItemReportConfig(response: Response): Promise<ReportV2ConfigOfSaleLineItemReportV2RequestAndReportWidgetTypesNone[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportV2ConfigOfSaleLineItemReportV2RequestAndReportWidgetTypesNone[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportV2ConfigOfSaleLineItemReportV2RequestAndReportWidgetTypesNone[]>(null as any);
    }

    upsertSaleLineItemReportConfig(reportConfig: ReportV2ConfigOfSaleLineItemReportV2RequestAndReportWidgetTypesNone, signal?: AbortSignal | undefined): Promise<number | null> {
        let url_ = this.baseUrl + "/api/ReportV2Config/UpsertSaleLineItemReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportConfig);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertSaleLineItemReportConfig(_response);
        });
    }

    protected processUpsertSaleLineItemReportConfig(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    getAvailablePurchaseOrderLineItemReportConfig(signal?: AbortSignal | undefined): Promise<ReportV2ConfigOfPurchaseOrderLineItemReportV2RequestAndReportWidgetTypesNone[]> {
        let url_ = this.baseUrl + "/api/ReportV2Config/GetAvailablePurchaseOrderLineItemReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailablePurchaseOrderLineItemReportConfig(_response);
        });
    }

    protected processGetAvailablePurchaseOrderLineItemReportConfig(response: Response): Promise<ReportV2ConfigOfPurchaseOrderLineItemReportV2RequestAndReportWidgetTypesNone[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportV2ConfigOfPurchaseOrderLineItemReportV2RequestAndReportWidgetTypesNone[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportV2ConfigOfPurchaseOrderLineItemReportV2RequestAndReportWidgetTypesNone[]>(null as any);
    }

    upsertPurchaseOrderLineItemReportConfig(reportConfig: ReportV2ConfigOfPurchaseOrderLineItemReportV2RequestAndReportWidgetTypesNone, signal?: AbortSignal | undefined): Promise<number | null> {
        let url_ = this.baseUrl + "/api/ReportV2Config/UpsertPurchaseOrderLineItemReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportConfig);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertPurchaseOrderLineItemReportConfig(_response);
        });
    }

    protected processUpsertPurchaseOrderLineItemReportConfig(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    getAvailableSoldTicketReportConfig(signal?: AbortSignal | undefined): Promise<ReportV2ConfigOfSoldTicketReportV2RequestAndReportWidgetTypesNone[]> {
        let url_ = this.baseUrl + "/api/ReportV2Config/GetAvailableSoldTicketReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableSoldTicketReportConfig(_response);
        });
    }

    protected processGetAvailableSoldTicketReportConfig(response: Response): Promise<ReportV2ConfigOfSoldTicketReportV2RequestAndReportWidgetTypesNone[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportV2ConfigOfSoldTicketReportV2RequestAndReportWidgetTypesNone[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportV2ConfigOfSoldTicketReportV2RequestAndReportWidgetTypesNone[]>(null as any);
    }

    upsertSoldTicketReportConfig(reportConfig: ReportV2ConfigOfSoldTicketReportV2RequestAndReportWidgetTypesNone, signal?: AbortSignal | undefined): Promise<number | null> {
        let url_ = this.baseUrl + "/api/ReportV2Config/UpsertSoldTicketReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportConfig);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertSoldTicketReportConfig(_response);
        });
    }

    protected processUpsertSoldTicketReportConfig(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    deleteReportConfig(reportConfigId: number | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ReportV2Config/DeleteReportConfig?";
        if (reportConfigId === null)
            throw new Error("The parameter 'reportConfigId' cannot be null.");
        else if (reportConfigId !== undefined)
            url_ += "reportConfigId=" + encodeURIComponent("" + reportConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteReportConfig(_response);
        });
    }

    protected processDeleteReportConfig(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getAvailableCommissionReportConfig(signal?: AbortSignal | undefined): Promise<ReportV2ConfigOfCommissionReportV2RequestAndReportWidgetTypesNone[]> {
        let url_ = this.baseUrl + "/api/ReportV2Config/GetAvailableCommissionReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableCommissionReportConfig(_response);
        });
    }

    protected processGetAvailableCommissionReportConfig(response: Response): Promise<ReportV2ConfigOfCommissionReportV2RequestAndReportWidgetTypesNone[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportV2ConfigOfCommissionReportV2RequestAndReportWidgetTypesNone[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportV2ConfigOfCommissionReportV2RequestAndReportWidgetTypesNone[]>(null as any);
    }

    getAvailableCostOfGoodsSoldReportConfig(signal?: AbortSignal | undefined): Promise<ReportV2ConfigOfCostOfGoodsSoldReportV2RequestAndReportWidgetTypesNone[]> {
        let url_ = this.baseUrl + "/api/ReportV2Config/GetAvailableCostOfGoodsSoldReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableCostOfGoodsSoldReportConfig(_response);
        });
    }

    protected processGetAvailableCostOfGoodsSoldReportConfig(response: Response): Promise<ReportV2ConfigOfCostOfGoodsSoldReportV2RequestAndReportWidgetTypesNone[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportV2ConfigOfCostOfGoodsSoldReportV2RequestAndReportWidgetTypesNone[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportV2ConfigOfCostOfGoodsSoldReportV2RequestAndReportWidgetTypesNone[]>(null as any);
    }

    upsertCostOfGoodsSoldReportConfig(reportConfig: ReportV2ConfigOfCostOfGoodsSoldReportV2RequestAndReportWidgetTypesNone, signal?: AbortSignal | undefined): Promise<number | null> {
        let url_ = this.baseUrl + "/api/ReportV2Config/UpsertCostOfGoodsSoldReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportConfig);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertCostOfGoodsSoldReportConfig(_response);
        });
    }

    protected processUpsertCostOfGoodsSoldReportConfig(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    getAvailableSaleTotalCostAdjustmentReportConfig(signal?: AbortSignal | undefined): Promise<ReportV2ConfigOfSaleTotalCostAdjustmentReportV2RequestAndReportWidgetTypesNone[]> {
        let url_ = this.baseUrl + "/api/ReportV2Config/GetAvailableSaleTotalCostAdjustmentReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableSaleTotalCostAdjustmentReportConfig(_response);
        });
    }

    protected processGetAvailableSaleTotalCostAdjustmentReportConfig(response: Response): Promise<ReportV2ConfigOfSaleTotalCostAdjustmentReportV2RequestAndReportWidgetTypesNone[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportV2ConfigOfSaleTotalCostAdjustmentReportV2RequestAndReportWidgetTypesNone[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportV2ConfigOfSaleTotalCostAdjustmentReportV2RequestAndReportWidgetTypesNone[]>(null as any);
    }

    upsertSaleTotalCostAdjustmentReportConfig(reportConfig: ReportV2ConfigOfSaleTotalCostAdjustmentReportV2RequestAndReportWidgetTypesNone, signal?: AbortSignal | undefined): Promise<number | null> {
        let url_ = this.baseUrl + "/api/ReportV2Config/UpsertSaleTotalCostAdjustmentReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportConfig);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertSaleTotalCostAdjustmentReportConfig(_response);
        });
    }

    protected processUpsertSaleTotalCostAdjustmentReportConfig(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    getAvailableTicketGroupReportConfig(signal?: AbortSignal | undefined): Promise<ReportV2ConfigOfTicketGroupReportV2RequestAndReportWidgetTypesNone[]> {
        let url_ = this.baseUrl + "/api/ReportV2Config/GetAvailableTicketGroupReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableTicketGroupReportConfig(_response);
        });
    }

    protected processGetAvailableTicketGroupReportConfig(response: Response): Promise<ReportV2ConfigOfTicketGroupReportV2RequestAndReportWidgetTypesNone[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportV2ConfigOfTicketGroupReportV2RequestAndReportWidgetTypesNone[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportV2ConfigOfTicketGroupReportV2RequestAndReportWidgetTypesNone[]>(null as any);
    }

    upsertTicketGroupReportConfig(reportConfig: ReportV2ConfigOfTicketGroupReportV2RequestAndReportWidgetTypesNone, signal?: AbortSignal | undefined): Promise<number | null> {
        let url_ = this.baseUrl + "/api/ReportV2Config/UpsertTicketGroupReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportConfig);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertTicketGroupReportConfig(_response);
        });
    }

    protected processUpsertTicketGroupReportConfig(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    upsertReportConfigOverride(reportConfigId: number | undefined, reportConfigOverride: ReportV2ConfigOverride, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ReportV2Config/UpsertReportConfigOverride?";
        if (reportConfigId === null)
            throw new Error("The parameter 'reportConfigId' cannot be null.");
        else if (reportConfigId !== undefined)
            url_ += "reportConfigId=" + encodeURIComponent("" + reportConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportConfigOverride);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertReportConfigOverride(_response);
        });
    }

    protected processUpsertReportConfigOverride(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}
export interface IReportV2Client {

    getInventoryReportMetrics(query: InventoryReportV2Request): Promise<ReportMetricsV2>;

    getInventoryReportSummary(query: InventoryReportV2Request): Promise<ReportMetricsSummaryV2>;

    downloadListingReportMetrics(query: InventoryReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined): Promise<FileResponse>;

    getSaleReportMetrics(query: SalesReportV2Request): Promise<ReportMetricsV2>;

    getSaleReportSummary(query: SalesReportV2Request): Promise<ReportMetricsSummaryV2>;

    downloadSaleReportMetrics(query: SalesReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined): Promise<FileResponse>;

    getCommissionReportMetrics(query: CommissionReportV2Request): Promise<ReportMetricsV2>;

    getCommissionReportSummary(query: CommissionReportV2Request): Promise<ReportMetricsSummaryV2>;

    downloadCommissionReportMetrics(query: CommissionReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined): Promise<FileResponse>;

    getPurchaseReportMetrics(query: PurchaseReportV2Request): Promise<ReportMetricsV2>;

    getPurchaseReportSummary(query: PurchaseReportV2Request): Promise<ReportMetricsSummaryV2>;

    downloadPurchaseReportMetrics(query: PurchaseReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined): Promise<FileResponse>;

    getSaleLineItemReportMetrics(query: SaleLineItemReportV2Request): Promise<ReportMetricsV2>;

    getSaleLineItemReportSummary(query: SaleLineItemReportV2Request): Promise<ReportMetricsSummaryV2>;

    downloadSaleLineItemReportMetrics(query: SaleLineItemReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined): Promise<FileResponse>;

    getPurchaseOrderLineItemReportMetrics(query: PurchaseOrderLineItemReportV2Request): Promise<ReportMetricsV2>;

    getPurchaseOrderLineItemReportSummary(query: PurchaseOrderLineItemReportV2Request): Promise<ReportMetricsSummaryV2>;

    downloadPurchaseOrderLineItemReportMetrics(query: PurchaseOrderLineItemReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined): Promise<FileResponse>;

    getSoldTicketReportMetrics(query: SoldTicketReportV2Request): Promise<ReportMetricsV2>;

    getSoldTicketReportSummary(query: SoldTicketReportV2Request): Promise<ReportMetricsSummaryV2>;

    getCatalogCountForInventoryReport(query: UIReportV2ListingQuery): Promise<CatalogCounts>;

    getCatalogCountForSalesReport(query: UIReportV2SaleQuery): Promise<CatalogCounts>;

    getCatalogCountForSaleLineItemReport(query: UIReportV2SaleLineItemQuery): Promise<CatalogCounts>;

    getCatalogCountForSoldTicketReport(query: UIReportV2SoldTicketQuery): Promise<CatalogCounts>;

    downloadSoldTicketReportMetrics(query: SoldTicketReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined): Promise<FileResponse>;

    getCostOfGoodsSoldReportMetrics(query: CostOfGoodsSoldReportV2Request): Promise<ReportMetricsV2>;

    getCostOfGoodsSoldReportSummary(query: CostOfGoodsSoldReportV2Request): Promise<ReportMetricsSummaryV2>;

    downloadCostOfGoodsSoldReportMetrics(query: CostOfGoodsSoldReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined): Promise<FileResponse>;

    getCatalogCountForCostOfGoodsSoldReport(query: UIReportV2CostOfGoodsSoldQuery): Promise<CatalogCounts>;

    getSaleTotalCostAdjustmentReportMetrics(query: SaleTotalCostAdjustmentReportV2Request): Promise<ReportMetricsV2>;

    getSaleTotalCostAdjustmentReportSummary(query: SaleTotalCostAdjustmentReportV2Request): Promise<ReportMetricsSummaryV2>;

    downloadSaleTotalCostAdjustmentReportMetrics(query: SaleTotalCostAdjustmentReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined): Promise<FileResponse>;

    getCatalogCountForSaleTotalCostAdjustmentReport(query: UIReportV2SaleTotalCostAdjustmentsQuery): Promise<CatalogCounts>;

    getTicketGroupReportMetrics(query: TicketGroupReportV2Request): Promise<ReportMetricsV2>;

    getTicketGroupReportSummary(query: TicketGroupReportV2Request): Promise<ReportMetricsSummaryV2>;

    downloadTicketGroupReportMetrics(query: TicketGroupReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined): Promise<FileResponse>;

    getCatalogCountForTicketGroupReport(query: UIReportV2TicketGroupQuery): Promise<CatalogCounts>;

    /**
     * Dummy endpoint to expose FileExportResult class to the client
     */
    getEmptyFileExportResult(): Promise<FileExportResult>;

    /**
     * Dummy endpoint to expose FileExportProgress class to the client
     */
    getEmptyFileExportProgress(): Promise<FileExportProgress>;
}

export class ReportV2Client extends PosClientBase implements IReportV2Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getInventoryReportMetrics(query: InventoryReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetInventoryReportMetrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInventoryReportMetrics(_response);
        });
    }

    protected processGetInventoryReportMetrics(response: Response): Promise<ReportMetricsV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsV2>(null as any);
    }

    getInventoryReportSummary(query: InventoryReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsSummaryV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetInventoryReportSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInventoryReportSummary(_response);
        });
    }

    protected processGetInventoryReportSummary(response: Response): Promise<ReportMetricsSummaryV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsSummaryV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsSummaryV2>(null as any);
    }

    downloadListingReportMetrics(query: InventoryReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ReportV2/DownloadListingReportMetrics?";
        if (reportName === null)
            throw new Error("The parameter 'reportName' cannot be null.");
        else if (reportName !== undefined)
            url_ += "reportName=" + encodeURIComponent("" + reportName) + "&";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (supportBackgroundProcess === null)
            throw new Error("The parameter 'supportBackgroundProcess' cannot be null.");
        else if (supportBackgroundProcess !== undefined)
            url_ += "supportBackgroundProcess=" + encodeURIComponent("" + supportBackgroundProcess) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadListingReportMetrics(_response);
        });
    }

    protected processDownloadListingReportMetrics(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSaleReportMetrics(query: SalesReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetSaleReportMetrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSaleReportMetrics(_response);
        });
    }

    protected processGetSaleReportMetrics(response: Response): Promise<ReportMetricsV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsV2>(null as any);
    }

    getSaleReportSummary(query: SalesReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsSummaryV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetSaleReportSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSaleReportSummary(_response);
        });
    }

    protected processGetSaleReportSummary(response: Response): Promise<ReportMetricsSummaryV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsSummaryV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsSummaryV2>(null as any);
    }

    downloadSaleReportMetrics(query: SalesReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ReportV2/DownloadSaleReportMetrics?";
        if (reportName === null)
            throw new Error("The parameter 'reportName' cannot be null.");
        else if (reportName !== undefined)
            url_ += "reportName=" + encodeURIComponent("" + reportName) + "&";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (supportBackgroundProcess === null)
            throw new Error("The parameter 'supportBackgroundProcess' cannot be null.");
        else if (supportBackgroundProcess !== undefined)
            url_ += "supportBackgroundProcess=" + encodeURIComponent("" + supportBackgroundProcess) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadSaleReportMetrics(_response);
        });
    }

    protected processDownloadSaleReportMetrics(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getCommissionReportMetrics(query: CommissionReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetCommissionReportMetrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCommissionReportMetrics(_response);
        });
    }

    protected processGetCommissionReportMetrics(response: Response): Promise<ReportMetricsV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsV2>(null as any);
    }

    getCommissionReportSummary(query: CommissionReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsSummaryV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetCommissionReportSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCommissionReportSummary(_response);
        });
    }

    protected processGetCommissionReportSummary(response: Response): Promise<ReportMetricsSummaryV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsSummaryV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsSummaryV2>(null as any);
    }

    downloadCommissionReportMetrics(query: CommissionReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ReportV2/DownloadCommissionReportMetrics?";
        if (reportName === null)
            throw new Error("The parameter 'reportName' cannot be null.");
        else if (reportName !== undefined)
            url_ += "reportName=" + encodeURIComponent("" + reportName) + "&";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (supportBackgroundProcess === null)
            throw new Error("The parameter 'supportBackgroundProcess' cannot be null.");
        else if (supportBackgroundProcess !== undefined)
            url_ += "supportBackgroundProcess=" + encodeURIComponent("" + supportBackgroundProcess) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadCommissionReportMetrics(_response);
        });
    }

    protected processDownloadCommissionReportMetrics(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getPurchaseReportMetrics(query: PurchaseReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetPurchaseReportMetrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPurchaseReportMetrics(_response);
        });
    }

    protected processGetPurchaseReportMetrics(response: Response): Promise<ReportMetricsV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsV2>(null as any);
    }

    getPurchaseReportSummary(query: PurchaseReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsSummaryV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetPurchaseReportSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPurchaseReportSummary(_response);
        });
    }

    protected processGetPurchaseReportSummary(response: Response): Promise<ReportMetricsSummaryV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsSummaryV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsSummaryV2>(null as any);
    }

    downloadPurchaseReportMetrics(query: PurchaseReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ReportV2/DownloadPurchaseReportMetrics?";
        if (reportName === null)
            throw new Error("The parameter 'reportName' cannot be null.");
        else if (reportName !== undefined)
            url_ += "reportName=" + encodeURIComponent("" + reportName) + "&";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (supportBackgroundProcess === null)
            throw new Error("The parameter 'supportBackgroundProcess' cannot be null.");
        else if (supportBackgroundProcess !== undefined)
            url_ += "supportBackgroundProcess=" + encodeURIComponent("" + supportBackgroundProcess) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadPurchaseReportMetrics(_response);
        });
    }

    protected processDownloadPurchaseReportMetrics(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSaleLineItemReportMetrics(query: SaleLineItemReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetSaleLineItemReportMetrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSaleLineItemReportMetrics(_response);
        });
    }

    protected processGetSaleLineItemReportMetrics(response: Response): Promise<ReportMetricsV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsV2>(null as any);
    }

    getSaleLineItemReportSummary(query: SaleLineItemReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsSummaryV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetSaleLineItemReportSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSaleLineItemReportSummary(_response);
        });
    }

    protected processGetSaleLineItemReportSummary(response: Response): Promise<ReportMetricsSummaryV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsSummaryV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsSummaryV2>(null as any);
    }

    downloadSaleLineItemReportMetrics(query: SaleLineItemReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ReportV2/DownloadSaleLineItemReportMetrics?";
        if (reportName === null)
            throw new Error("The parameter 'reportName' cannot be null.");
        else if (reportName !== undefined)
            url_ += "reportName=" + encodeURIComponent("" + reportName) + "&";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (supportBackgroundProcess === null)
            throw new Error("The parameter 'supportBackgroundProcess' cannot be null.");
        else if (supportBackgroundProcess !== undefined)
            url_ += "supportBackgroundProcess=" + encodeURIComponent("" + supportBackgroundProcess) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadSaleLineItemReportMetrics(_response);
        });
    }

    protected processDownloadSaleLineItemReportMetrics(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getPurchaseOrderLineItemReportMetrics(query: PurchaseOrderLineItemReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetPurchaseOrderLineItemReportMetrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPurchaseOrderLineItemReportMetrics(_response);
        });
    }

    protected processGetPurchaseOrderLineItemReportMetrics(response: Response): Promise<ReportMetricsV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsV2>(null as any);
    }

    getPurchaseOrderLineItemReportSummary(query: PurchaseOrderLineItemReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsSummaryV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetPurchaseOrderLineItemReportSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPurchaseOrderLineItemReportSummary(_response);
        });
    }

    protected processGetPurchaseOrderLineItemReportSummary(response: Response): Promise<ReportMetricsSummaryV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsSummaryV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsSummaryV2>(null as any);
    }

    downloadPurchaseOrderLineItemReportMetrics(query: PurchaseOrderLineItemReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ReportV2/DownloadPurchaseOrderLineItemReportMetrics?";
        if (reportName === null)
            throw new Error("The parameter 'reportName' cannot be null.");
        else if (reportName !== undefined)
            url_ += "reportName=" + encodeURIComponent("" + reportName) + "&";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (supportBackgroundProcess === null)
            throw new Error("The parameter 'supportBackgroundProcess' cannot be null.");
        else if (supportBackgroundProcess !== undefined)
            url_ += "supportBackgroundProcess=" + encodeURIComponent("" + supportBackgroundProcess) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadPurchaseOrderLineItemReportMetrics(_response);
        });
    }

    protected processDownloadPurchaseOrderLineItemReportMetrics(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSoldTicketReportMetrics(query: SoldTicketReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetSoldTicketReportMetrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSoldTicketReportMetrics(_response);
        });
    }

    protected processGetSoldTicketReportMetrics(response: Response): Promise<ReportMetricsV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsV2>(null as any);
    }

    getSoldTicketReportSummary(query: SoldTicketReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsSummaryV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetSoldTicketReportSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSoldTicketReportSummary(_response);
        });
    }

    protected processGetSoldTicketReportSummary(response: Response): Promise<ReportMetricsSummaryV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsSummaryV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsSummaryV2>(null as any);
    }

    getCatalogCountForInventoryReport(query: UIReportV2ListingQuery, signal?: AbortSignal | undefined): Promise<CatalogCounts> {
        let url_ = this.baseUrl + "/api/ReportV2/GetCatalogCountForInventoryReport/GetCatalogCountForInventoryReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCatalogCountForInventoryReport(_response);
        });
    }

    protected processGetCatalogCountForInventoryReport(response: Response): Promise<CatalogCounts> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogCounts;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogCounts>(null as any);
    }

    getCatalogCountForSalesReport(query: UIReportV2SaleQuery, signal?: AbortSignal | undefined): Promise<CatalogCounts> {
        let url_ = this.baseUrl + "/api/ReportV2/GetCatalogCountForSalesReport/GetCatalogCountForSalesReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCatalogCountForSalesReport(_response);
        });
    }

    protected processGetCatalogCountForSalesReport(response: Response): Promise<CatalogCounts> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogCounts;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogCounts>(null as any);
    }

    getCatalogCountForSaleLineItemReport(query: UIReportV2SaleLineItemQuery, signal?: AbortSignal | undefined): Promise<CatalogCounts> {
        let url_ = this.baseUrl + "/api/ReportV2/GetCatalogCountForSaleLineItemReport/GetCatalogCountForSaleLineItemReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCatalogCountForSaleLineItemReport(_response);
        });
    }

    protected processGetCatalogCountForSaleLineItemReport(response: Response): Promise<CatalogCounts> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogCounts;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogCounts>(null as any);
    }

    getCatalogCountForSoldTicketReport(query: UIReportV2SoldTicketQuery, signal?: AbortSignal | undefined): Promise<CatalogCounts> {
        let url_ = this.baseUrl + "/api/ReportV2/GetCatalogCountForSoldTicketReport/GetCatalogCountForSoldTicketReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCatalogCountForSoldTicketReport(_response);
        });
    }

    protected processGetCatalogCountForSoldTicketReport(response: Response): Promise<CatalogCounts> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogCounts;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogCounts>(null as any);
    }

    downloadSoldTicketReportMetrics(query: SoldTicketReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ReportV2/DownloadSoldTicketReportMetrics?";
        if (reportName === null)
            throw new Error("The parameter 'reportName' cannot be null.");
        else if (reportName !== undefined)
            url_ += "reportName=" + encodeURIComponent("" + reportName) + "&";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (supportBackgroundProcess === null)
            throw new Error("The parameter 'supportBackgroundProcess' cannot be null.");
        else if (supportBackgroundProcess !== undefined)
            url_ += "supportBackgroundProcess=" + encodeURIComponent("" + supportBackgroundProcess) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadSoldTicketReportMetrics(_response);
        });
    }

    protected processDownloadSoldTicketReportMetrics(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getCostOfGoodsSoldReportMetrics(query: CostOfGoodsSoldReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetCostOfGoodsSoldReportMetrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCostOfGoodsSoldReportMetrics(_response);
        });
    }

    protected processGetCostOfGoodsSoldReportMetrics(response: Response): Promise<ReportMetricsV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsV2>(null as any);
    }

    getCostOfGoodsSoldReportSummary(query: CostOfGoodsSoldReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsSummaryV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetCostOfGoodsSoldReportSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCostOfGoodsSoldReportSummary(_response);
        });
    }

    protected processGetCostOfGoodsSoldReportSummary(response: Response): Promise<ReportMetricsSummaryV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsSummaryV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsSummaryV2>(null as any);
    }

    downloadCostOfGoodsSoldReportMetrics(query: CostOfGoodsSoldReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ReportV2/DownloadCostOfGoodsSoldReportMetrics?";
        if (reportName === null)
            throw new Error("The parameter 'reportName' cannot be null.");
        else if (reportName !== undefined)
            url_ += "reportName=" + encodeURIComponent("" + reportName) + "&";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (supportBackgroundProcess === null)
            throw new Error("The parameter 'supportBackgroundProcess' cannot be null.");
        else if (supportBackgroundProcess !== undefined)
            url_ += "supportBackgroundProcess=" + encodeURIComponent("" + supportBackgroundProcess) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadCostOfGoodsSoldReportMetrics(_response);
        });
    }

    protected processDownloadCostOfGoodsSoldReportMetrics(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getCatalogCountForCostOfGoodsSoldReport(query: UIReportV2CostOfGoodsSoldQuery, signal?: AbortSignal | undefined): Promise<CatalogCounts> {
        let url_ = this.baseUrl + "/api/ReportV2/GetCatalogCountForCostOfGoodsSoldReport/GetCatalogCountForCostOfGoodsSoldReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCatalogCountForCostOfGoodsSoldReport(_response);
        });
    }

    protected processGetCatalogCountForCostOfGoodsSoldReport(response: Response): Promise<CatalogCounts> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogCounts;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogCounts>(null as any);
    }

    getSaleTotalCostAdjustmentReportMetrics(query: SaleTotalCostAdjustmentReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetSaleTotalCostAdjustmentReportMetrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSaleTotalCostAdjustmentReportMetrics(_response);
        });
    }

    protected processGetSaleTotalCostAdjustmentReportMetrics(response: Response): Promise<ReportMetricsV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsV2>(null as any);
    }

    getSaleTotalCostAdjustmentReportSummary(query: SaleTotalCostAdjustmentReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsSummaryV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetSaleTotalCostAdjustmentReportSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSaleTotalCostAdjustmentReportSummary(_response);
        });
    }

    protected processGetSaleTotalCostAdjustmentReportSummary(response: Response): Promise<ReportMetricsSummaryV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsSummaryV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsSummaryV2>(null as any);
    }

    downloadSaleTotalCostAdjustmentReportMetrics(query: SaleTotalCostAdjustmentReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ReportV2/DownloadSaleTotalCostAdjustmentReportMetrics?";
        if (reportName === null)
            throw new Error("The parameter 'reportName' cannot be null.");
        else if (reportName !== undefined)
            url_ += "reportName=" + encodeURIComponent("" + reportName) + "&";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (supportBackgroundProcess === null)
            throw new Error("The parameter 'supportBackgroundProcess' cannot be null.");
        else if (supportBackgroundProcess !== undefined)
            url_ += "supportBackgroundProcess=" + encodeURIComponent("" + supportBackgroundProcess) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadSaleTotalCostAdjustmentReportMetrics(_response);
        });
    }

    protected processDownloadSaleTotalCostAdjustmentReportMetrics(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getCatalogCountForSaleTotalCostAdjustmentReport(query: UIReportV2SaleTotalCostAdjustmentsQuery, signal?: AbortSignal | undefined): Promise<CatalogCounts> {
        let url_ = this.baseUrl + "/api/ReportV2/GetCatalogCountForSaleTotalCostAdjustmentReport/GetCatalogCountForSaleTotalCostAdjustmentReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCatalogCountForSaleTotalCostAdjustmentReport(_response);
        });
    }

    protected processGetCatalogCountForSaleTotalCostAdjustmentReport(response: Response): Promise<CatalogCounts> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogCounts;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogCounts>(null as any);
    }

    getTicketGroupReportMetrics(query: TicketGroupReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetTicketGroupReportMetrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTicketGroupReportMetrics(_response);
        });
    }

    protected processGetTicketGroupReportMetrics(response: Response): Promise<ReportMetricsV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsV2>(null as any);
    }

    getTicketGroupReportSummary(query: TicketGroupReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsSummaryV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetTicketGroupReportSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTicketGroupReportSummary(_response);
        });
    }

    protected processGetTicketGroupReportSummary(response: Response): Promise<ReportMetricsSummaryV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsSummaryV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsSummaryV2>(null as any);
    }

    downloadTicketGroupReportMetrics(query: TicketGroupReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ReportV2/DownloadTicketGroupReportMetrics?";
        if (reportName === null)
            throw new Error("The parameter 'reportName' cannot be null.");
        else if (reportName !== undefined)
            url_ += "reportName=" + encodeURIComponent("" + reportName) + "&";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (supportBackgroundProcess === null)
            throw new Error("The parameter 'supportBackgroundProcess' cannot be null.");
        else if (supportBackgroundProcess !== undefined)
            url_ += "supportBackgroundProcess=" + encodeURIComponent("" + supportBackgroundProcess) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadTicketGroupReportMetrics(_response);
        });
    }

    protected processDownloadTicketGroupReportMetrics(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getCatalogCountForTicketGroupReport(query: UIReportV2TicketGroupQuery, signal?: AbortSignal | undefined): Promise<CatalogCounts> {
        let url_ = this.baseUrl + "/api/ReportV2/GetCatalogCountForTicketGroupReport/GetCatalogCountForTicketGroupReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCatalogCountForTicketGroupReport(_response);
        });
    }

    protected processGetCatalogCountForTicketGroupReport(response: Response): Promise<CatalogCounts> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogCounts;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogCounts>(null as any);
    }

    /**
     * Dummy endpoint to expose FileExportResult class to the client
     */
    getEmptyFileExportResult(signal?: AbortSignal | undefined): Promise<FileExportResult> {
        let url_ = this.baseUrl + "/api/ReportV2/GetEmptyFileExportResult/GetEmptyFileExportResult";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEmptyFileExportResult(_response);
        });
    }

    protected processGetEmptyFileExportResult(response: Response): Promise<FileExportResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileExportResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileExportResult>(null as any);
    }

    /**
     * Dummy endpoint to expose FileExportProgress class to the client
     */
    getEmptyFileExportProgress(signal?: AbortSignal | undefined): Promise<FileExportProgress> {
        let url_ = this.baseUrl + "/api/ReportV2/GetEmptyFileExportProgress/GetEmptyFileExportProgress";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEmptyFileExportProgress(_response);
        });
    }

    protected processGetEmptyFileExportProgress(response: Response): Promise<FileExportProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileExportProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileExportProgress>(null as any);
    }
}
